import React from 'react';
import { Box } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  box: {
    padding: '20px 15px',
    display: 'flex',
    height: 175,
    justifySelf: 'stretch',
  },
  boxText: {
    fontSize: '1rem',
  },
  boxNumberWithIcon: {
    fontSize: '1.5rem',
  },
  circularChartContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  circularChartCircleContainer: {
    position: 'relative',
    height: '7rem',
    width: '7rem',
    marginRight: '1rem',
    flexShrink: 0,
  },
  circularChartCircle: {
    position: 'absolute',
    top: 0,
    left: 0,
    '& circle': {
      strokeWidth: 7,
    },
  },
  circularChartValue: {
    fontSize: '1.5rem',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  circle: {
    color: 'rgba(0, 0, 0, .1)',
  },
}));

const CircularChart = ({
  projectsNumber,
  value,
  percentValue,
  label,
  icon,
  gridArea,
  color,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.box} style={{ gridArea: gridArea }} boxShadow={3}>
      <div className={classes.circularChartContainer}>
        <div className={classes.circularChartCircleContainer}>
          <CircularProgress
            size='7rem'
            value={100}
            thickness={10}
            variant='determinate'
            className={classes.circularChartCircle}
            classes={{
              circle: classes.circle,
            }}
          />
          <CircularProgress
            size='7rem'
            value={percentValue}
            thickness={10}
            variant='determinate'
            style={{ color: color ? color : '#0069B4' }}
            className={classes.circularChartCircle}
          />
          <span className={classes.circularChartValue}>
            {Math.round(percentValue)}%
          </span>
        </div>
        <div>
          <p className={classes.boxNumberWithIcon}>
            {value}
            {icon}
          </p>
          <p className={classes.boxText}>{label}</p>
        </div>
      </div>
    </Box>
  );
};

export default CircularChart;
